import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import Post from "../../components/post";
import { useSelector } from "react-redux";

export default function Tagged({ username, token }) {
  const [taggedPosts, setTaggedPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const { user } = useSelector((state) => ({ ...state }));
  const loadTaggedPosts = useCallback(async () => {
    try {
      setLoading(true);
      setError("");
      
      const response = await axios.get(`/getTaggedPosts/${username}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      
      if (response.data.status === "ok") {
        setTaggedPosts(response.data.posts);
      } else {
        setError(response.data.message || "Failed to load tagged posts");
      }
    } catch (error) {
      console.error("Error loading tagged posts:", error);
      setError("Failed to load tagged posts");
    } finally {
      setLoading(false);
    }
  }, [username, token]);

  useEffect(() => {
    loadTaggedPosts();
  }, [loadTaggedPosts]);

  if (loading) {
    return (
      <div className="profile_card">
        <div className="profile_card_header">
          Tagged
        </div>
        <div className="content_loading">
          <div className="spinner">
            <div className="bounce1"></div>
            <div className="bounce2"></div>
            <div className="bounce3"></div>
          </div>
          <span>Loading tagged posts...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="profile_card">
        <div className="profile_card_header">
          Tagged
        </div>
        <div className="no_tagged_posts">
          <div style={{ 
            textAlign: "center", 
            padding: "20px", 
            color: "#65676b",
            fontSize: "14px"
          }}>
            {error}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="profile_card">
      <div className="profile_card_header">
        Tagged
        <div className="profile_header_link">
          {taggedPosts.length} posts
        </div>
      </div>
      <div className="profile_card_count">
        {taggedPosts.length === 0
          ? "No tagged posts"
          : taggedPosts.length === 1
          ? "1 tagged post"
          : `${taggedPosts.length} tagged posts`}
      </div>
      
      {taggedPosts.length > 0 ? (
        <div className="tagged_posts_list">
          {taggedPosts.map((post) => (
            <Post 
              key={post._id} 
              post={post} 
              user={user} 
              profile 
            />
          ))}
        </div>
      ) : (
        <div className="no_tagged_posts">
          <div style={{ 
            textAlign: "center", 
            padding: "20px", 
            color: "#65676b",
            fontSize: "14px"
          }}>
            No posts where you're tagged yet
          </div>
        </div>
      )}
    </div>
  );
} 